import { useLocation } from 'react-router';
import { bindActionCreators, Dispatch } from 'redux';
import { connect, RootStateOrAny } from 'react-redux';

import { saveHedisClaim, updateMemberMeasureForClaimSubmission, validateHedisClaim } from 'store/eligibility/claimGenerator/actions';
import { checkBulkCPTCompability } from 'store/claim/ndc/actions';
import { getForMember as getMemberMeasures } from 'store/eligibility/measures/actions';

import FinalSubmissionPage from 'components/Eligibility/ClaimGenerator/FinalSubmission';

interface ClaimGeneratorFinalSubmissionPageProps {
  saveHedisClaim(claim: any): any;
  checkBulkCPTCompability(array: any): any;
  getMemberMeasures(memberInfo: any, measureYear: number, memberMeasureStatus: string): any;
  updateMemberMeasureForClaimSubmission(measure: any, claimStatus: string, measureStatus: string, measureYear: any, claimReferenceNo: string): any;
  validateHedisClaim(claimModel: Object): any;
  isSavingHedisClaim: boolean;
}

const ClaimGeneratorFinalSubmissionPage = (props: ClaimGeneratorFinalSubmissionPageProps) => {

  const location: any = useLocation();

  return (
    <>
      <FinalSubmissionPage
        memberInfo={location.state.eligibilityMemberInfo}
        provider={location.state.primaryCareProvider}
        dos={location.state.dos}
        measures={location.state.measures}
        saveHedisClaim={props.saveHedisClaim}
        checkBulkCPTCompability={props.checkBulkCPTCompability}
        getMemberMeasures={props.getMemberMeasures}
        updateMemberMeasureForClaimSubmission={props.updateMemberMeasureForClaimSubmission}
        validateHedisClaim={props.validateHedisClaim}
        isSavingHedisClaim={props.isSavingHedisClaim}
        measureYear={location.state.measureYear}
      />
    </>
  );
}

const mapStateToProps = (store: RootStateOrAny) => ({
  isSavingHedisClaim: store.rootReducer.eligibilityClaimGenerator.isSavingHedisClaim, //Saves to Hedis Claim
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  {
    saveHedisClaim,
    checkBulkCPTCompability,
    getMemberMeasures,
    updateMemberMeasureForClaimSubmission,
    validateHedisClaim,
  },
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(ClaimGeneratorFinalSubmissionPage);
